import DashBoardLayout from './DashBoardLayout';

export default DashBoardLayout;
